/** @format */

import {CategoriesFromQuery, CompanyFromQuery} from '../types';
import {getUniqueObjects} from './getUniqueObjects';

const getCategories = (companies: ReadonlyArray<CompanyFromQuery>): CategoriesFromQuery[] => {
  const accountCategoriesDto = companies.flatMap(v => v.tags).flatMap(v => v.category);
  return getUniqueObjects(accountCategoriesDto, 'id');
};

export {getCategories};
